export enum ContactCardColor {
  LIGHT = "light",
  PRIMARY = "primary",
}
